<div>
    <button [matMenuTriggerFor]="menu" class="show-actions">
        <i class="fas fa-ellipsis-h"></i>
    </button>

    <mat-menu #menu="matMenu">
        <button id="make-admin" mat-menu-item
                *ngIf="!isAdmin(member) && !adminRequestSent"
                (click)="makeAdmin(member)" [disableRipple]="true">
            <i class="fas fa-check"></i>
            <span>Make admin</span>
        </button>
        <button id="remove-make-admin" mat-menu-item *ngIf="isAdmin(member)"
                (click)="removeAdminPrivileges(member)" [disableRipple]="true">
            <i class="fas fa-times"></i>
            <span>Remove group admin privileges</span>
        </button>
        <button id="remove-make-moderator" mat-menu-item
                *ngIf="isModerator(member)"
                (click)="removeAdminPrivileges(member)" [disableRipple]="true">
            <i class="fas fa-times"></i>
            <span>Remove group moderator privileges</span>
        </button>
        <button id="make-moderator" *ngIf="!isModerator(member) && !moderatorRequestSent" mat-menu-item
                (click)="makeAdmin(member,'moderator')"
                [disableRipple]="true">
            <i class="fas fa-check"></i>
            <span>Make moderator</span>
        </button>
        <button id="remove-member-btn" mat-menu-item [disableRipple]="true" (click)="removeMember(member)">
            <i class="fas fa-times"></i>
            <span>Remove</span>
        </button>
    </mat-menu>
</div>
